import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService, GET, Adapter, POST, Body, Query } from '@royalty/httpclient';

@Injectable()
export class ConfigurationService extends HttpService {
	/**
	 * Floor
	 */
	@GET('floor/list')
	@Adapter(null, { isAdmin: true })
	getFloors(): Observable<any> {
		return null;
	}

	@GET('floor/getbyid')
	@Adapter(null, { isAdmin: true })
	getFloor(@Query('id') id: number): Observable<any> {
		return null;
	}

	@POST('floor/create')
	@Adapter(null, { isAdmin: true })
	createFloor(@Body data: string): Observable<any> {
		return null;
	}

	@POST('floor/update')
	@Adapter(null, { isAdmin: true })
	updateFloor(@Body data: string): Observable<any> {
		return null;
	}

	@POST('floor/delete')
	@Adapter(null, { isAdmin: true })
	deleteFloor(@Body data: string): Observable<any> {
		return null;
	}

	/**
	 * Tables
	 */
	@GET('adminTable/list')
	@Adapter(null, { isAdmin: true })
	getTables(): Observable<any> {
		return null;
	}

	@GET('adminTable/getbyid')
	@Adapter(null, { isAdmin: true })
	getTable(@Query('id') id: number): Observable<any> {
		return null;
	}

	@POST('adminTable/create')
	@Adapter(null, { isAdmin: true })
	createTable(@Body data: string): Observable<any> {
		return null;
	}

	@POST('adminTable/update')
	@Adapter(null, { isAdmin: true })
	updateTable(@Body data: string): Observable<any> {
		return null;
	}

	@POST('adminTable/delete')
	@Adapter(null, { isAdmin: true })
	deleteTable(@Body data: string): Observable<any> {
		return null;
	}
}
